var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTopBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77111 0.849808C5.81055 0.888228 5.97919 1.0333 6.11791 1.16843C6.99035 1.96068 8.41835 4.02741 8.85423 5.10913C8.92427 5.27341 9.07251 5.68875 9.08203 5.91065C9.08203 6.12329 9.03307 6.32599 8.93379 6.51941C8.79507 6.76053 8.57679 6.95396 8.31907 7.05994C8.14023 7.12817 7.60507 7.23416 7.59555 7.23416C7.01007 7.34014 6.05875 7.39844 5.00747 7.39844C4.00583 7.39844 3.09327 7.34014 2.49895 7.25337C2.48943 7.24343 1.82439 7.13745 1.59659 7.02152C1.18043 6.80889 0.922031 6.39355 0.922032 5.94907L0.922032 5.91065C0.932231 5.62118 1.19063 5.01242 1.20015 5.01242C1.63671 3.98899 2.99467 1.96995 3.89703 1.15849C3.89703 1.15849 4.12891 0.92996 4.27375 0.830598C4.48183 0.675593 4.73955 0.598753 4.99727 0.598753C5.28491 0.598753 5.55283 0.685529 5.77111 0.849808Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopBold);
export default __webpack_public_path__ + "static/media/arrow_top_bold.278f27091862aeedd8113cfa2790a27d.svg";
export { ForwardRef as ReactComponent };